<template>
<div>
  <e-chart ref="chart" />
</div>
</template>

<script>
import EChart from '../../../../../components/Charts/ECharts'

export default {
  name: 'FactorSourceAvgPieChart',
  components: {EChart},
  props: {
    sourceNameConfigs: {
      required: true,
      type: Array
    },
    dataMap: {
      required: true,
      type: Object
    }
  },
  methods: {
    renderChart () {
      const {sourceNameConfigs} = this
      const dataList = Object.values(this.dataMap)
      const avg = sourceNameConfigs.reduce((map, sourceNameConfig) => {
        const sourceId = sourceNameConfig.id
        let values = dataList.filter(data => Number.isFinite(data[sourceId]))
        const {length} = values
        map[sourceId] = length > 0 ? values.reduce((sum, data) => sum + data[sourceId], 0) / length : null
        return map
      }, {})
      const chartOpt = {
        title: {
          text: '平均时间',
          left: 'center'
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        tooltip: {
          trigger: 'item',
          appendToBody: true
        },
        color: sourceNameConfigs.map(sourceNameConfig => sourceNameConfig.color),
        series: [{
          name: '平均时间',
          type: 'pie',
          // radius: '100px',
          startAngle: 0,
          label: {
            show: true,
            position: 'inside',
            formatter: '{b}:{d}%',
            color: '#000000'
          },
          data: Object.entries(avg).map(([name, value]) => ({
            name,
            value: Number.isFinite(value) ? Number(value.toFixed(2)) : value
          }))
        }]
      }

      this.$refs.chart.setOpt(chartOpt, true)
    }
  },
  mounted () {
    setTimeout(() => {
      this.renderChart()
    }, 0)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/FactorSourceAvgPieChart.vue